import { type ReactNode } from 'react'
import { TolgeeProvider as TolgeeBaseProvider } from '@tolgee/react'

import type { LocationLanguage } from './types'

interface I18nProviderProps {
  children: ReactNode
  apiKey?: string
  apiUrl?: string
  /** CDN path for dynamic translation loading */
  filesUrlPrefix?: string
  loadingFallback?: ReactNode
  defaultLanguage?: LocationLanguage
}

export const I18nProvider = ({
  children,
  apiKey,
  apiUrl,
  filesUrlPrefix = '/i18n/',
  loadingFallback,
  defaultLanguage,
}: I18nProviderProps) => {
  return (
    <TolgeeBaseProvider
      apiKey={apiKey}
      apiUrl={apiUrl}
      filesUrlPrefix={filesUrlPrefix}
      wrapperMode="text"
      {...(defaultLanguage ? { defaultLanguage } : {})}
      loadingFallback={loadingFallback}
    >
      {children}
    </TolgeeBaseProvider>
  )
}
